import React, { useState, useRef, useEffect } from 'react'
import ConnectingLines from './ui/ConnectingLines'
import VerticalTimeline from './ui/VerticalTimeline'
import { Users, BarChart2, Heart } from 'lucide-react'
import { mockData } from '../mock'

// SÓ ADICIONEI ISSO ⬇️
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

const AboutSection = () => {
  const [hovered, setHovered] = useState(null)
  const { sponsors } = mockData
  const sectionRef = useRef(null)

  useEffect(() => {
    const el = sectionRef.current
    if (!el) return
    const onMove = (e) => {
      const rect = el.getBoundingClientRect()
      const dx = (e.clientX - (rect.left + rect.width / 2)) / rect.width
      const dy = (e.clientY - (rect.top + rect.height / 2)) / rect.height
      el.style.setProperty('--tx', `${dx * 4}deg`)
      el.style.setProperty('--ty', `${dy * -4}deg`)
    }
    window.addEventListener('mousemove', onMove)
    return () => window.removeEventListener('mousemove', onMove)
  }, [])

  const DepthCard = ({ children, onHover, index, rotateRange = 15 }) => {
    const r = useRef(null)
    useEffect(() => {
      const el = r.current
      if (!el) return
      const onMove = (e) => {
        const rect = el.getBoundingClientRect()
        const px = (e.clientX - rect.left) / rect.width
        const py = (e.clientY - rect.top) / rect.height
        el.style.transform = `perspective(1000px) rotateX(${(py - 0.5) * rotateRange}deg) rotateY(${(px - 0.5) * -rotateRange}deg) scale3d(1.05, 1.05, 1.05)`
      }
      const onLeave = () => { el.style.transform = '' }
      el.addEventListener('mousemove', onMove)
      el.addEventListener('mouseleave', onLeave)
      return () => {
        el.removeEventListener('mousemove', onMove)
        el.removeEventListener('mouseleave', onLeave)
      }
    }, [rotateRange])

    return (
      <div ref={r} onMouseEnter={() => onHover && onHover(index)} onMouseLeave={() => onHover && onHover(null)} className="transform-gpu transition-all duration-300 ease-out" style={{transformStyle: 'preserve-3d'}}>
        {children}
      </div>
    )
  }

  return (
    <section id="sobre" ref={sectionRef} className="relative overflow-hidden bg-[#05040a] text-white py-28" style={{'--tx': '0deg', '--ty': '0deg'}}>
      
      {/* LINHAS ONDULADAS DE FUNDO */}
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <svg className="w-full h-full" viewBox="0 0 1440 800" fill="none">
          <path d="M-100 600C200 500 400 750 720 600C1040 450 1240 700 1540 600" stroke="url(#grad1)" strokeWidth="3" fill="none" className="animate-pulse" />
          <path d="M-100 500C300 400 500 650 820 500C1140 350 1340 600 1640 500" stroke="url(#grad2)" strokeWidth="2" fill="none" opacity="0.5" />
          <defs>
            <linearGradient id="grad1"><stop offset="0%" stopColor="#ff6a3d" /><stop offset="100%" stopColor="#7b2ff7" /></linearGradient>
            <linearGradient id="grad2"><stop offset="0%" stopColor="#7b2ff7" /><stop offset="100%" stopColor="#ff6a3d" /></linearGradient>
          </defs>
        </svg>
      </div>

      <div className="container mx-auto px-6 lg:px-24 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-32" style={{transform: 'rotateX(var(--ty)) rotateY(var(--tx))'}}>
          
          <div className="relative pl-10 lg:pl-36">
            <VerticalTimeline height={520} />
            
            <h2 className="text-7xl md:text-[8rem] leading-[0.9] font-black mb-6 tracking-tighter about-title drop-shadow-2xl">
              Nossa<br/>História
            </h2>
            
            <div className="w-32 h-1.5 rounded-full bg-gradient-to-r from-orange-500 via-rose-500 to-purple-600 mb-10 shadow-[0_0_15px_rgba(249,115,22,0.4)]" />
            
            <div className="space-y-6">
              <p className="text-gray-200 max-w-xl leading-relaxed text-xl font-medium"> 
                O UNIFICADOS nasceu do desejo de criar um espaço onde jovens possam se conectar com Deus e uns com os outros de forma autêntica. 
              </p>
              <p className="text-gray-400 max-w-xl leading-relaxed text-lg italic border-l-2 border-orange-500/30 pl-6">
                Acreditamos que quando nos unimos em propósito e fé, somos capazes de transformar não apenas nossas vidas, mas toda a comunidade ao nosso redor.
              </p>
            </div>
          </div>

          <div className="relative space-y-8 mt-10">
            {[
              { label: "Edições Realizadas", val: "2", icon: <BarChart2 size={32}/> },
              { label: "Jovens Alcançados", val: "+100", icon: <Users size={32}/> }
            ].map((card, i) => (
              <DepthCard key={i} index={i} onHover={setHovered}>
                <div className="flex items-center gap-8 p-10 rounded-[32px] bg-[#0b1020]/90 border border-white/10 shadow-3d group transition-all duration-500 hover:border-orange-500/40">
                  <div className="w-24 h-24 rounded-2xl flex items-center justify-center bg-gradient-to-br from-orange-500 to-rose-600 shadow-[0_10px_20px_rgba(249,115,22,0.3)] group-hover:scale-110 transition-transform">
                    {card.icon}
                  </div>
                  <div>
                    <div className="text-4xl font-black text-white">{card.val}</div>
                    <div className="text-xs text-gray-400 font-bold uppercase tracking-[0.2em]">{card.label}</div>
                  </div>
                </div>
              </DepthCard>
            ))}
          </div>
        </div>

        {/* ========================================== */}
        {/* SEÇÃO DE PATROCINADORES - SOMENTE CARROSSEL */}
        {/* ========================================== */}
        <div className="flex flex-col items-center pt-20">
          <div className="text-center mb-20">
            <span className="text-orange-500 font-black text-sm md:text-base tracking-[0.8em] uppercase bg-orange-500/15 px-10 py-4 rounded-full border-2 border-orange-500/30 shadow-[0_0_30px_rgba(249,115,22,0.2)] inline-block mb-4">
              Parceiros Oficiais
            </span>
            
            <h3 className="text-6xl md:text-7xl font-black text-white mt-8 tracking-tight">
              Apoio de <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-orange-500 to-rose-600">Peso</span>
            </h3>
          </div>
          
          {/* CARROSSEL - SÓ ISSO MUDA */}
          <div className="w-full max-w-7xl mx-auto px-4">
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={24}
              slidesPerView={1}
              navigation={true}
              autoplay={{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true }}
              loop={true}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 3, spaceBetween: 24 },
                1024: { slidesPerView: 4, spaceBetween: 24 },
                1280: { slidesPerView: 5, spaceBetween: 24 },
              }}
              className="sponsors-carousel"
            >
              {sponsors.partners.map((partner, index) => (
                <SwiperSlide key={index}>
                  <div className="group relative">
                    <div className="absolute -inset-1 bg-gradient-to-r from-orange-600 to-rose-600 rounded-[40px] blur opacity-10 group-hover:opacity-100 transition duration-700" />
                    <div className="relative bg-[#0b1020] rounded-[38px] p-6 flex flex-col items-center border border-white/5 shadow-2xl backdrop-blur-2xl">
                      <div className="relative h-40 w-40 rounded-full overflow-hidden bg-black mb-4">
                        <img 
                          src={partner.logo} 
                          alt={partner.name} 
                          className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
                        />
                      </div>
                      <div className="text-center px-4">
                        <h4 className="text-white font-black text-xl uppercase tracking-tight group-hover:text-orange-400 transition-colors">
                          {partner.name}
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>

      <style>{`
        .about-title {
          background: linear-gradient(135deg, #ffffff 20%, #ffd6c2 50%, #9a9a9a 80%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          filter: drop-shadow(0 15px 30px rgba(0,0,0,0.8));
        }
        .shadow-3d { box-shadow: 0 30px 60px rgba(0,0,0,0.6), 0 1px 2px rgba(255,255,255,0.1) inset; }
        @keyframes pulse-slow { 0%, 100% { opacity: 0.2; transform: translateY(0); } 50% { opacity: 0.5; transform: translateY(-10px); } }
        .animate-pulse { animation: pulse-slow 6s ease-in-out infinite; }
        
        .sponsors-carousel {
          padding-bottom: 1rem;
        }
        .sponsors-carousel .swiper-button-next,
        .sponsors-carousel .swiper-button-prev {
          background-color: #0b1020;
          width: 44px;
          height: 44px;
          border-radius: 9999px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.5);
          color: #f97316;
          transition: all 0.3s ease;
          border: 1px solid rgba(255,255,255,0.1);
        }
        .sponsors-carousel .swiper-button-next:after,
        .sponsors-carousel .swiper-button-prev:after {
          font-size: 18px;
          font-weight: bold;
        }
        .sponsors-carousel .swiper-button-next:hover,
        .sponsors-carousel .swiper-button-prev:hover {
          background-color: #f97316;
          color: white;
        }
        @media (max-width: 768px) {
          .sponsors-carousel .swiper-button-next,
          .sponsors-carousel .swiper-button-prev {
            display: none;
          }
        }
        .sponsors-carousel .swiper-slide {
          height: auto;
        }
      `}</style>
    </section>
  )
}

export default AboutSection